import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { CiLocationArrow1 } from "react-icons/ci";
import Api_Instance from "../../api/Api_Instance";
import { Startups } from "../../api/endpoints";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setFilter } from "../../redux/slice/Slice";
import { MdMail } from "react-icons/md";
import { IoCall } from "react-icons/io5";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import Upcomingevents from "../upcomingevents/Upcomingevents";
function Startup() {
  const api = Api_Instance.unAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const handleMouseEnter = (index) => setHoveredItemIndex(index);
  const handleMouseLeave = () => setHoveredItemIndex(null);
  const item = data?.slice(0, 4)
  const [hoveredItemIndex, setHoveredItemIndex] = useState(null);
  const getApi = async () => {
    try {
      const res = await api("GET", Startups.GET_STARTUPS);
      setData(res?.data?.data);
    } catch { }
  };

  useEffect(() => {
    getApi();
  }, []);

  const mainCarouselItems = data
    ?.filter((item) => item.status)
    .slice(0, 4)
    .map((item, index) => (
      <div key={item.id} className="bg-[#f9f8f8] rounded-lg hover:[box-shadow:inset_0_1px_1px_rgba(0,_0,_0,_.075),_0_0_8px_rgb(0_0_0_/_20%)] p-2 mx-2  " onMouseEnter={() => handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave} >
        <img
          className="w-full h-32 border border-gray-200 rounded-md"
          src={`${item?.business_pic}`}
          alt={"image"}
        />

        {/* Hover Carousel */}
        {/* {hoveredItemIndex === index && (
          <div className="absolute inset-0 bg-opacity-90 flex items-center justify-center rounded-md h-36 ">
            <AliceCarousel
              mouseTracking
              items={data?.map((item, i) => (
                <div className="max-w-[380px] mx-auto h-[150px] mt-3">
                  <img
                    key={i}
                    className="h-[150px] w-full rounded-md"
                    src={item.business_pic}
                    alt={`Hover-${i}`}
                  />
                </div>
              ))}
              autoPlay
              infinite
              autoPlayInterval={1000}
              disableDotsControls
              disableButtonsControls
            />
          </div>
        )} */}
        <div>
          <p className="text-sm text-gray-600 mt-4">{item.sector}</p>
          <h3 className="text-lg font-semibold text-gray-800 truncate w-full">
            {item.business_type}
          </h3>
          <div className="mt-2">
            <div className="flex justify-between text-sm text-gray-600">
              <p>Asking Price</p>
              <p>₹{item.annual_sales}</p>
            </div>
            <div className="flex justify-between items-center gap-2 mt-3">
              <a className="mt-2 flex gap-2" href={`tel:${item.phone}`}>

                <span className="text-xl flex justify-center items-center w-7 h-7 rounded-full !border !border-1 border-[#4A5661]">
                  <IoCall className="text-[#4A5661] text-[14px]" />
                </span>
                <p className="text-md">Call</p>
              </a>
              <a href={`tel:${item.email}`} className="mt-2 flex gap-2">
                <span className="text-xl flex justify-center items-center w-7 h-7 rounded-full !border !border-1 border-[#4A5661]">
                  <MdMail className="text-[#4A5661] text-[14px]" />
                </span>
                <p className="text-md">Email</p>
              </a>
              <div className="mt-2 flex gap-2">
                <a
                  href={item?.startup_website_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex gap-2 items-center"
                >
                  <span className="text-xl flex justify-center items-center w-7 h-7 rounded-full !border !border-1 border-[#4A5661]">
                    <CiLocationArrow1 className="text-[#4A5661] text-[14px]" />
                  </span>
                  {/* <p className="text-md underline text-blue-600">{item.location}</p> */}
                </a>
              </div>

            </div>
          </div>
          <NavLink to="/startupdetails" state={{ item: item }}>
            <div className="border-2 rounded-md border-gray-600 mt-3 text-center text-sm text-gray-800 py-2 cursor-pointer button button4">
              <p className="">
                Explore
                <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
              </p>
            </div>
          </NavLink>
        </div>
      </div>

    ));
  return (
    <div className="w-full max-w-[1250px] mx-auto xl:px-0 lg:px-0 md:px-5 px-4 mt-5xl px-0 lg:px-0 md:px-5 px-4">



      <div className="flex flex-wrap">
        <div className="w-[100%] pb-4 md:w-[60%] md:pb-0 lg:w-[70%]">
          <div className="2xl:mb-5 xl:mb-5 lg:mb-5 md:mb-4 mb-3">
            <h1 className="text-start font-bold 2xl:text-[32px] xl:text-[32px] lg:text-[32px] md:text-4xl text-2xl xl:mb-5 lg:mb-5 md:mb-5 mb-3 ">
              High Growth Potential
              <span className="text-secondaryColor ml-2">Startups</span>
            </h1>
            <hr className="mb-[20px]" />
          </div>

          <div className={`${item?.length === 1 || item?.length === 2 || item?.length === 3 ? "Carsouleitemwidth" : ""}`}>
            {item?.length === 1 || item?.length === 2 || item?.length === 3 ?
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 sm:gap-5 mx-auto md:gap-2-important lg:gap-0-important xl:gap-0-important gap-4">
                {item?.map((item, index) => (
                  <div key={item.id} className="bg-[#f9f8f8] rounded-lg hover:[box-shadow:inset_0_1px_1px_rgba(0,_0,_0,_.075),_0_0_8px_rgb(0_0_0_/_20%)] p-2 mx-2" onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave} >
                    <img
                      className="w-full h-32 border border-gray-200 rounded-md"
                      src={`${item?.business_pic}`}
                      alt={"image"}
                    />
                    <div>
                      <p className="text-sm text-gray-600 mt-4">{item.sector}</p>
                      <h3 className="text-lg font-semibold text-gray-800 truncate w-full">
                        {item.business_type}
                      </h3>
                      <div className="mt-2">
                        <div className="flex justify-between text-sm text-gray-600">
                          <p>Asking Price</p>
                          <p>₹{item.annual_sales}</p>
                        </div>
                        <div className="flex justify-between items-center gap-2 mt-3">
                          <a className="mt-2 flex gap-2" href={`tel:${item.phone}`}>

                            <span className="text-xl flex justify-center items-center w-7 h-7 rounded-full !border !border-1 border-[#4A5661]">
                              <IoCall className="text-[#4A5661] text-[14px]" />
                            </span>
                            <p className="text-md">Call</p>
                          </a>
                          <a href={`tel:${item.email}`} className="mt-2 flex gap-2">
                            <span className="text-xl flex justify-center items-center w-7 h-7 rounded-full !border !border-1 border-[#4A5661]">
                              <MdMail className="text-[#4A5661] text-[14px]" />
                            </span>
                            <p className="text-md">Email</p>
                          </a>
                          <div className="mt-2 flex gap-2">
                            <span className="text-xl flex justify-center items-center w-7 h-7 rounded-full !border !border-1 border-[#4A5661]">
                              <CiLocationArrow1 className="text-[#4A5661] text-[14px]" />
                            </span>
                            {/* <p className="text-md">{item.location}</p> */}
                          </div>
                        </div>
                      </div>
                      <NavLink to="/startupdetails" state={{ item: item }}>
                        <div className="border-2 rounded-md border-gray-600 mt-3 text-center text-sm text-gray-800 py-2 cursor-pointer button button4">
                          <p className="">
                            Explore
                            <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
                          </p>
                        </div>
                      </NavLink>
                    </div>
                  </div>
                ))
                } </div> : (

                <AliceCarousel
                  mouseTracking
                  items={mainCarouselItems}
                  autoPlay
                  infinite
                  autoPlayInterval={2000}
                  disableDotsControls
                  disableButtonsControls
                  responsive={{
                    0: { items: 1 },
                    768: { items: 2 },
                    1024: { items: 2 },
                    1280: { items: 3 },
                  }}
                />
              )}


          </div>
          <div className="flex justify-center items-center  2xl:mt-5 xl:mt-5 md:mt-5 mt-2">
        <div className="border-2 border-[#4A5661] bg-[#4A5661] text-white border-gray-600 text-center text-sm text-gray-800 py-2 w-60 rounded-md 2xl:mt-[50px] xl:mt-[50px] lg:mt-[50px] md:mt-[50px] mt-[30px] cursor-pointer hover:[box-shadow:0_0_10px_0_#4a5661_inset,_0_0_20px_2px_#4a5661]">
          <p
            className=""
            onClick={() => {
              dispatch(setFilter(data));
              navigate(`/saledetails`, { state: { item: data } });
            }}
          >
            VIEW ALL
            <FontAwesomeIcon icon={faArrowRight} className="ml-1" />
          </p>
        </div>
      </div>
        </div>

        <div className="w-[100%] md:w-[40%] lg:w-[30%]">
        <Upcomingevents />
        </div>
      </div>





    

    </div>
  );
}

export default Startup;
